import { Button, Calendar, Tag } from 'primereact';
import React, { useEffect, useState } from 'react'

import AgGrid from '../../../../../Base/Components/Tables/AgGrid/AgGrid';

import { colorCotton, colorSintetico } from '../../../../../Styles/Colors';

export const SalidasCocinasScreen = ({ salidasQC, loading, plantaTratamiento }) => {



    const CategoriaTemplate = (rowData) => {
        switch (rowData.Categoria) {
            case 'Cotton':
                return <Tag severity='danger' className='col-12' value={rowData.Categoria} style={{ backgroundColor: colorCotton }} />
                break;
            case 'Synthetic':
                return <Tag severity='info' className='col-12' value={rowData.Categoria} style={{ backgroundColor: colorSintetico }} />
                break;
            case 'Spandex':
                return <Tag className='col-12' value={rowData.Categoria} style={{ backgroundColor: '#ffc605' }} />
                break;

            default:
                return <div>{rowData.Categoria}</div>
                break;
        }
    }
    const TipoTemplate = (rowData) => {
        switch (rowData.NombreTipo) {
            case 'Quimicos':
                return <Tag severity='danger' className='col-12' value={rowData.NombreTipo} style={{ backgroundColor: colorCotton }} />
                break;
            case 'Colorantes':
                return <Tag severity='info' className='col-12' value={rowData.NombreTipo} style={{ backgroundColor: colorSintetico }} />
                break;
            case 'Spandex':
                return <Tag className='col-12' value={rowData.NombreTipo} style={{ backgroundColor: '#ffc605' }} />
                break;

            default:
                return <div>{rowData.NombreTipo}</div>
                break;
        }
    }


    const colums = [
        {
            header: 'Fecha',
            field: 'Fecha',
            Format: 'DateTime'
        },
        {
            header: 'No Salida',
            field: 'IdSalida',
            className: 'small'
        },
        {
            header: 'Categoria',
            field: 'Categoria',
            className: 'small',
            Format: 'Template',
            body: CategoriaTemplate,
            hidden: plantaTratamiento ? false : true
        },
        {
            header: 'Nombre Tipo',
            field: 'NombreTipo',
            className: 'small',
            Format: 'Template',
            body: TipoTemplate
        },
        {
            header: 'Producto',
            field: 'NombreProducto',
            className: 'XXlarge',
            Sumary: 'count'
        },
        {
            header: 'Cantidad(Kgs)',
            field: 'CantIngresada',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum'
        },
        {
            header: 'Precio',
            field: 'Precio',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum'
        },
        {
            header: 'Monto',
            field: 'Monto',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum'
        },
        {
            header: 'Tipo Salida',
            field: 'TipoSalida',
            className: 'small',
            hidden: plantaTratamiento ? false : true
        },
        {
            header: 'Proveedor',
            field: 'Proveedor',
            className: 'XXlarge'
        },
        {
            header: 'Partida',
            field: 'IdDyeGroup',
            className: 'Xsmall',
            hidden: plantaTratamiento ? false : true
        },
        {
            header: 'Densidad',
            field: 'Densidad',
            className: 'small',
            hidden: plantaTratamiento ? false : true
        },
        {
            header: 'ColorName',
            field: 'ColorName',
            className: 'medium',
            hidden: plantaTratamiento ? false : true
        },
        {
            header: 'Lab Dip',
            field: 'LabDip',
            className: 'medium',
            hidden: plantaTratamiento ? false : true
        },
        {
            header: 'No Ingreso',
            field: 'IdIngreso',
            className: 'small'
        },
        {
            header: 'Entregado Por',
            field: 'EntregadoPor',
        },
        {
            header: 'Comentario',
            field: 'Comentario',
            className: 'Xlarge'
        },

    ]

    const table = {
        Data: salidasQC,
        Columns: colums,
        loading: loading
    }


    return (
        <div className='p-2' style={{ height: '80vh' }}>
            <AgGrid table={table} />
        </div>
    )
}
